import { render } from "./DeleteFolderConfirmationModalComponent.vue?vue&type=template&id=131c95e8&ts=true"
import script from "./DeleteFolderConfirmationModalComponent.vue?vue&type=script&lang=ts"
export * from "./DeleteFolderConfirmationModalComponent.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__